<template>
  <div class="con">
    <Nav />
    <div class="newsdetail">
      <div class="newsbody">
        <h2>{{ article.title }}</h2>
        <div class="time">{{ fmtTime }}</div>

        <div class="content" v-html="article.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { GetNews } from "@/api/api";
export default {
  components: {},
  data() {
    return {
      article: {},
    };
  },
  computed: {
    fmtTime() {
      var t = this.article.createTime;
      if (t) {
        return dayjs(t).format("YYYY年M月D日");
      }
      return "";
    },
  },
  created() {
    console.log(this.$route.params);
    var { id } = this.$route.params;
    if (id) {
      this.getData(id);
    }
  },
  methods: {
    getData(id) {
      GetNews(id).then((res) => {
        var { code, data } = res;
        if (code === 0) {
          if (data.content) {
            var pattern = /https:\/\/www.westmoney10.com\/api\/cos/g
            data.content = data.content.replace(pattern, process.env.VUE_APP_COS_BASE_URL)
          }
          this.article = data;
        }
      });
    },
  },
};
</script>
<style lang="less">
.newsdetail {
  padding-top: 52px;

  .newsbody {
    padding: 27px 15px;

    h2 {
      font-size: 24px;
      line-height: 160%;
      font-weight: normal;
      color: #242a32;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .time {
      font-size: 14px;
      color: #9fa4a8;
      margin-top: 10px;
      margin-bottom: 32px;
    }

    .content {
      p {
        font-size: 16px;
        line-height: 30px;
        color: #242A32;
        margin-bottom: 30px;
      }

      img {
        display: block;
        max-width: 100%;
        height: auto !important;
      }
    }
  }
}
</style>